import { render, staticRenderFns } from "./solutionTab.vue?vue&type=template&id=72dff710&scoped=true&"
import script from "./solutionTab.vue?vue&type=script&lang=js&"
export * from "./solutionTab.vue?vue&type=script&lang=js&"
import style0 from "./solutionTab.vue?vue&type=style&index=0&id=72dff710&lang=sass&scoped=true&"
import style1 from "./solutionTab.vue?vue&type=style&index=1&id=72dff710&lang=scss&scoped=true&"
import style2 from "./solutionTab.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./solutionTab.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dff710",
  null
  
)

export default component.exports